<script>
import axios from 'axios'

export default {
  name: 'RequestCancelTokenMixin',
  data () {
    return {
      requestToken: false,
      requestCancelMessage: 'Start new request'
    }
  },
  methods: {
    /**
     * Check if there's a pending request then
     * - Cancel the old cancellation token
     * - Create a new cancellation token
     */
    requestCancelTokenChecker () {
      this.requestCancelToken()
      this.requestToken = axios.CancelToken.source()
    },
    /**
     * Clear the cancellation token after request completion
     */
    requestCancelTokenClearer () {
      this.requestToken = false
    },
    /**
     * Remove a cancellation token if it exists
     */
    requestCancelToken () {
      if (this.requestToken) {
        this.requestToken.cancel(this.requestCancelMessage)
      }
    }
  }
}
</script>
